import {useState} from "react";
import {Modal} from "react-bootstrap";
import {ChatFeedbackInterface, ChatRating as Rating} from "../../interfaces/customer/ChatInterface";

const RATINGS: {value: Rating, label: string}[] = [
    {value: 'good', label: 'Хорошо'},
    {value: 'medium', label: 'Средне'},
    {value: 'bad', label: 'Плохо'},
];

/**
 * Плашка под перепиской консультанта: оценка ответов и комментарий в модалке.
 * Оценка — на весь диалог, её можно поменять; ответы и отзыв видны в админке («Диалоги консультанта»).
 */
export default function ChatRating({feedback, onRate, onComment}: {
    feedback: ChatFeedbackInterface
    onRate: (rating: Rating) => void
    onComment: (liked: string, disliked: string) => Promise<void>
}) {
    const [open, setOpen] = useState(false);
    const [liked, setLiked] = useState('');
    const [disliked, setDisliked] = useState('');
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');
    const commented = !!(feedback.liked || feedback.disliked);

    const show = () => {
        setLiked(feedback.liked);
        setDisliked(feedback.disliked);
        setError('');
        setOpen(true);
    };

    const save = () => {
        setSaving(true);
        setError('');
        onComment(liked.trim(), disliked.trim())
            .then(() => setOpen(false))
            .catch((reason: any) => setError(reason.response?.data?.message || reason.message))
            .finally(() => setSaving(false));
    };

    return <div className="chat-rating">
        <span className="chat-rating__question">{feedback.rating ? 'Спасибо за оценку!' : 'Как вы оцениваете ответ?'}</span>
        <span className="chat-rating__buttons">
            {RATINGS.map(({value, label}) => (
                <button key={value} type="button"
                        className={'chat-rating__button chat-rating__button--' + value + (feedback.rating === value ? ' chat-rating__button--active' : '')}
                        onClick={() => onRate(value)}>
                    {label}
                </button>
            ))}
        </span>
        <button type="button" className="chat-rating__comment" onClick={show}>
            {commented ? 'изменить комментарий' : 'комментарий'}
        </button>

        <Modal show={open} onHide={() => !saving && setOpen(false)} centered dialogClassName="chat-rating-modal">
            <Modal.Header closeButton>
                <Modal.Title as="h5">Комментарий к ответам</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <label className="form-label" htmlFor="chat-rating-liked">Что понравилось</label>
                <textarea id="chat-rating-liked" className="form-control mb-3" rows={4} maxLength={4000}
                          value={liked} onChange={event => setLiked(event.target.value)}/>
                <label className="form-label" htmlFor="chat-rating-disliked">Что не понравилось</label>
                <textarea id="chat-rating-disliked" className="form-control" rows={4} maxLength={4000}
                          value={disliked} onChange={event => setDisliked(event.target.value)}/>
                {error && <div className="text-danger small mt-2">{error}</div>}
            </Modal.Body>
            <Modal.Footer>
                <button type="button" className="btn gray two" disabled={saving} onClick={() => setOpen(false)}>Отмена</button>
                <button type="button" className="btn btn-primary two" disabled={saving || (!liked.trim() && !disliked.trim() && !commented)} onClick={save}>
                    {saving ? 'Сохраняем…' : 'Отправить'}
                </button>
            </Modal.Footer>
        </Modal>
    </div>;
}
